import api from '../api';

// Reuses the existing bearer-token client and /tasks/ server URL mount.
const ROOT = '/tasks/finance';
export const getCatalog = async (signal) => (await api.get(`${ROOT}/catalog/`, { signal })).data;
export const getOverview = async (params, signal) => (await api.get(`${ROOT}/overview/`, { params, signal })).data;
export const getEntries = async (params, signal) => (await api.get(`${ROOT}/entries/`, { params, signal })).data;
export const getEntry = async (id) => (await api.get(`${ROOT}/entries/${id}/`)).data;
export const initialize = async () => (await api.post(`${ROOT}/initialize/`)).data;
export const saveEntry = async (id, data) => (await (id ? api.patch(`${ROOT}/entries/${id}/`, data) : api.post(`${ROOT}/entries/`, data))).data;
export const deleteEntry = async (id) => api.delete(`${ROOT}/entries/${id}/`);
export const saveResource = async (resource, id, data) => (await (id ? api.patch(`${ROOT}/${resource}/${id}/`, data) : api.post(`${ROOT}/${resource}/`, data))).data;
export const payEntry = async (id, data) => (await api.post(`${ROOT}/entries/${id}/payments/`, data)).data;
export const deletePayment = async (entryId, paymentId) => api.delete(`${ROOT}/entries/${entryId}/payments/${paymentId}/`);
export const generatePlan = async (data) => (await api.post(`${ROOT}/generate/`, data)).data;
export async function exportEntries(params) {
  const response = await api.get(`${ROOT}/export/`, { params, responseType: 'blob' });
  const url = URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `LunaDesk-finances-${params.month || 'all'}-${params.currency}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const savePreferences = async (data) => (await api.patch(`${ROOT}/preferences/`, data)).data;
export const deleteResource = async (resource, id) => api.delete(`${ROOT}/${resource}/${id}/`);
